
export class ModuleModel {
    moduleId: number;
    moduleName: string;
    moduleDesc: string;
    username: string;

    constructor(moduleId: number, moduleName: string, moduleDesc: string, username: string) {
        this.moduleId = moduleId;
        this.moduleDesc = moduleDesc;
        this.moduleName = moduleName;
        this.username = username;
    }
}
